"use client";

import { resetPwdSchema } from "@/01-core/user/user";
import { Button } from "@/03-presenters/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/03-presenters/components/ui/form";
import { Input } from "@/03-presenters/components/ui/input";
import { Label } from "@/03-presenters/components/ui/typography";
import { toast } from "@/03-presenters/components/ui/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { Modal, ModalContent, ModalBody, useDisclosure, ModalHeader } from "@nextui-org/react";
import { useRequest } from "ahooks";
import { Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";
export default function UpdateUserPassword() {
  const {
    isOpen,
    onOpen,
    onOpenChange,
    onClose
  } = useDisclosure();
  const form = useForm<z.infer<typeof resetPwdSchema>>({
    defaultValues: {
      password: "",
      passwordConfirm: ""
    },
    resolver: zodResolver(resetPwdSchema)
  });
  const {
    loading,
    runAsync
  } = useRequest(async data => {
    const res = await fetch(`/api/user/userPassword`, {
      method: "POST",
      body: JSON.stringify(data)
    });
    const json = await res.json();
    return json;
  }, {
    manual: true
  });
  async function onSubmit(data: z.infer<typeof resetPwdSchema>) {
    const res = await runAsync(data);
    if (res.code === 200) {
      toast({
        title: "设置密码成功",
        duration: 3000
      });
      onClose();
    } else {
      toast({
        title: "设置密码失败",
        variant: "destructive",
        duration: 3000
      });
    }
  }
  return <>
      <div className="flex items-center gap-2">
        <Label className="flex h-6 items-center text-nowrap" data-sentry-element="Label" data-sentry-source-file="UpdateUserPassword.tsx">用户密码: </Label>
        <Label className="flex h-6 items-center text-nowrap" data-sentry-element="Label" data-sentry-source-file="UpdateUserPassword.tsx">******</Label>
        <Button variant="link" className="h-6 text-primary hover:no-underline" onClick={onOpen} data-sentry-element="Button" data-sentry-source-file="UpdateUserPassword.tsx">
          设置
        </Button>
      </div>
      <Modal isOpen={isOpen} onOpenChange={isOpen => {
      if (!isOpen) {
        form.reset();
      }
      onOpenChange();
    }} size="md" data-sentry-element="Modal" data-sentry-source-file="UpdateUserPassword.tsx">
        <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="UpdateUserPassword.tsx">
          <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="UpdateUserPassword.tsx">设置密码</ModalHeader>
          <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="UpdateUserPassword.tsx">
            <Form {...form} data-sentry-element="Form" data-sentry-source-file="UpdateUserPassword.tsx">
              <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4">
                <FormField control={form.control} name="password" render={({
                field
              }) => <FormItem className="flex flex-col gap-2">
                      <FormControl>
                        <Input className="h-9" placeholder="请输入密码" {...field} type="password" onCopy={e => e.preventDefault()} onPaste={e => e.preventDefault()} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} data-sentry-element="FormField" data-sentry-source-file="UpdateUserPassword.tsx" />
                <FormField control={form.control} name="passwordConfirm" render={({
                field
              }) => <FormItem className="flex flex-col gap-2">
                      <FormControl>
                        <Input className="h-9" placeholder="确认密码" {...field} type="password" onCopy={e => e.preventDefault()} onPaste={e => e.preventDefault()} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>} data-sentry-element="FormField" data-sentry-source-file="UpdateUserPassword.tsx" />
                <Button type="submit" className="gradient-btn m-auto mt-4 h-7 w-fit px-8" disabled={loading} data-sentry-element="Button" data-sentry-source-file="UpdateUserPassword.tsx">
                  提交 {loading && <Loader2 className="ml-2 animate-spin" />}
                </Button>
              </form>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>;
}